import React from 'react';
import { Link } from 'react-router-dom';
import { Car, Check, Settings2 } from 'lucide-react';
import { vehicleStore, useSelectedVehicle } from '../services/vehicleStore';
import { useGarage } from '../services/garageStore';
import { useT } from '../services/i18n';
import VehicleBrandLogo from './VehicleBrandLogo';

// One-click switch between the vehicles saved in the customer's garage
const GarageQuickPick = ({ variant = 'chips', onPick, testId = 'garage-quick-pick' }) => {
  const { t } = useT();
  const garage = useGarage();
  const selected = useSelectedVehicle();
  if (!garage.length) return null;
  const pick = (v) => { vehicleStore.set({ brand: v.brand, model: v.model, year: v.year, engine: v.engine, plate: v.plate }); onPick?.(v); };
  const isSel = (v) => vehicleStore.same(selected, v);

  if (variant === 'menu') {
    return (
      <div data-testid={testId} className="py-1">
        <p className="px-3 py-1.5 text-[11px] font-semibold uppercase tracking-wide text-gray-400">{t('garage.myVehicles')}</p>
        {garage.map(v => (
          <button key={v.id} type="button" onClick={() => pick(v)} data-testid={`${testId}-item-${v.id}`}
            className={`w-full text-left px-3 py-2 text-sm flex items-center gap-2 hover:bg-gray-50 ${isSel(v) ? 'text-orange-600 font-medium' : 'text-gray-700'}`}>
            {isSel(v) ? <Check size={14} className="text-orange-500 shrink-0" /> : <VehicleBrandLogo brand={v.brand} model={v.model} bare size={18} fallbackClass="text-gray-400" testId={`${testId}-logo-${v.id}`} />}
            <span className="truncate">{v.label || `${v.brand} ${v.model}`} <span className="text-gray-400 font-normal">· {v.engine?.name}</span></span>
          </button>
        ))}
        <Link to="/mon-compte/garage" data-testid={`${testId}-manage`} className="block px-3 py-2 text-xs text-blue-600 hover:underline border-t border-gray-100 mt-1">
          <Settings2 size={12} className="inline mr-1" />{t('garage.manage')}
        </Link>
      </div>
    );
  }

  return (
    <div data-testid={testId} className="flex flex-wrap items-center gap-2 mb-4">
      <span className="text-xs font-semibold uppercase tracking-wide text-gray-500 flex items-center gap-1"><Car size={13} /> {t('garage.myVehicles')} :</span>
      {garage.map(v => (
        <button key={v.id} type="button" onClick={() => pick(v)} data-testid={`${testId}-item-${v.id}`}
          className={`inline-flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-full border transition-colors ${isSel(v) ? 'bg-orange-500 border-orange-500 text-white' : 'bg-white border-gray-300 text-gray-700 hover:border-orange-400 hover:text-orange-600'}`}>
          {isSel(v) ? <Check size={12} /> : <VehicleBrandLogo brand={v.brand} model={v.model} bare size={16} fallbackClass="text-gray-400" testId={`${testId}-logo-${v.id}`} />}{v.label || `${v.brand} ${v.model}`} <span className={isSel(v) ? 'text-orange-100' : 'text-gray-400'}>· {v.engine?.name}</span>
        </button>
      ))}
      <Link to="/mon-compte/garage" data-testid={`${testId}-manage`} className="text-xs text-blue-600 hover:underline">{t('garage.manage')}</Link>
    </div>
  );
};

export default GarageQuickPick;
